import { render, staticRenderFns } from "./EmbryoTransfer.vue?vue&type=template&id=0497da96&scoped=true&"
import script from "./EmbryoTransfer.vue?vue&type=script&lang=js&"
export * from "./EmbryoTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497da96",
  null
  
)

export default component.exports